import { render, staticRenderFns } from "./bmMenuButton.vue?vue&type=template&id=a025b01e&scoped=true&"
import script from "./bmMenuButton.vue?vue&type=script&lang=js&"
export * from "./bmMenuButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a025b01e",
  null
  
)

export default component.exports